import { ScheduleWeekDay } from '../../../../types/backendTypes/ScheduleWeekDay';

export const weekDays = [
  { name: 'Måndag', value: ScheduleWeekDay.Monday },
  { name: 'Tisdag', value: ScheduleWeekDay.Tuesday },
  { name: 'Onsdag', value: ScheduleWeekDay.Wednesday },
  { name: 'Torsdag', value: ScheduleWeekDay.Thursday },
  { name: 'Fredag', value: ScheduleWeekDay.Friday },
  { name: 'Lördag', value: ScheduleWeekDay.Saturday },
  { name: 'Söndag', value: ScheduleWeekDay.Sunday },
];
